import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Snackbar from "@material-ui/core/Snackbar";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { CheckBoxOutlined, WarningOutlined } from "@material-ui/icons";
import {CLEAR_DESIGNER_MESSAGE} from "../redux_store/jobState"

const useStyles = makeStyles({
    root: {
        background: "#313133",
        color: "white",
        padding: "8px",
        borderRadius: "5px",
        boxShadow: "5px 4px 10px #888888",
        font: '14px "Univers45", sans-serif',
        textAlign: "start",
        display: "flex",
        alignItems: "center",
    },
    success: {
        background: "#008200",
    },
    warning: {
        background: "#e79b36",
    },
    error: {
        background: "#EF4036",
    },
    snackbar: {
        zIndex: "10100",
    },
});

export default function Message(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [currentMessage, setCurrentMessage] = useState(null);

    useEffect(() => {
        if (props.open && props.message) {
            setCurrentMessage(props);
        }
    }, [props.open, props.message]);

    const handleClose = () => {
        dispatch({
            type: CLEAR_DESIGNER_MESSAGE,
        });
        setCurrentMessage(null);
    };

    return (
        <Snackbar
            classes={{ root: classes.snackbar }}
            open={currentMessage !== null}
            autoHideDuration={6000}
            onClose={handleClose}
        >
            {currentMessage && (
                <div className={`${classes.root} ${classes[currentMessage.type.toLowerCase()]}`}>
                    {currentMessage.type === "error" && (
                        <WarningOutlined style={{ width: "24px", height: "24px", marginRight: "8px", zIndex: 22 }} />
                    )}
                    {currentMessage.type === "warning" && (
                        <ErrorOutlineIcon style={{ width: "24px", height: "24px", marginRight: "8px", zIndex: 21 }} />
                    )}
                    {currentMessage.type === "success" && (
                        <CheckBoxOutlined style={{ width: "24px", height: "24px", marginRight: "8px", zIndex: 20 }} />
                    )}
                    <div style={{ display: "flex", flexDirection: "column" }}>{currentMessage.message}</div>
                </div>
            )}
        </Snackbar>
    );
}
